'use client';

import React, { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';

const calculatePercentage = (total: number, parts: number) => {
  const result = [];
  let next = 0;

  for (let i = parts - 1; i >= 0; i -= 1) {
    let value = 0;

    if (i === 0) {
      value = ((total / parts) + next);
    } else {
      value = ((total / parts) + next) / 2;
    }
    result.unshift(value);
    next = value;
  }

  return result;
};

interface Props {
  totalSections: number;
  currentSection: number;
}

export const ProgressBar: React.FC<Props> = ({ totalSections, currentSection }) => {
  const [progressPercentages, setProgressPercentages] = useState<number[]>([]);
  const progressBarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const w = calculatePercentage(100, totalSections);
    setProgressPercentages(w);
  }, [totalSections, currentSection]);

  return (
    <div className={styles.progressBar}>
      <div
        ref={progressBarRef}
        className={styles.progress}
        style={{
          transform: `scaleX(${progressPercentages.slice(0, currentSection).reduce((a, b) => a + b, 0)}%)`,
        }}
      />
    </div>
  );
};
